var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ivu-trend",class:_vm.classes},[_c('span',{staticClass:"ivu-trend-text"},[_vm._t("default")],2),_vm._v(" "),_c('Icon',{staticClass:"ivu-trend-flag",attrs:{"type":_vm.flagType}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/trend/trend.vue